var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state"},[_c('p',[_vm._v("原创声明，本文系作者授权发表，未经许可，不得转载。")]),_c('p',[_vm._v("如有侵权，请联系管理员删除。")])])}]

export { render, staticRenderFns }